export const PartnerService = (http) => ({
	async getPage(page) {
		const response = await http.get('/api/Partners/List', {
			params: {
				page,
				pageSize: 100,
			},
		});

		return response.data;
	},

	async getAll(page = 1, pageSize = 999999, state = undefined) {
		const response = await http.get('/api/Partners/List', {
			params: {
				page,
				pageSize,
				state,
			},
		});

		return response.data?.entities;
	},
});
